import { render, staticRenderFns } from "./OrdersStatistics.vue?vue&type=template&id=da0839da&scoped=true&"
import script from "./OrdersStatistics.vue?vue&type=script&lang=js&"
export * from "./OrdersStatistics.vue?vue&type=script&lang=js&"
import style0 from "./OrdersStatistics.vue?vue&type=style&index=0&id=da0839da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0839da",
  null
  
)

export default component.exports